import { render, staticRenderFns } from "./ScanDocuments.vue?vue&type=template&id=cb72e2aa&"
import script from "./ScanDocuments.vue?vue&type=script&lang=ts&"
export * from "./ScanDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports